export enum scrollTarget {
    GUIDE = 'guide',
    SCROLLBAR = 'scrollbar'
}